webpackJsonp([142629428675168],{

/***/ 445:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"html":"<div class=\"body section-content\">\n    <div class=\"inner-left\">\n        <h1>\n            Metoda Sp. z o.o.\n        </h1>\n        <div class=\"baner-text\">\n            <p>ul. Zajęcza 15, 00-351 Warszawa, Polska</p>\n            <p>NIP: 5222640671, REGON: 015146440</p>\n            <p>KRS: 0000108146</p>\n            <p>e-mail: biuro@metoda.com.pl</p>\n        </div>\n    </div>\n    <div class=\"inner-right\"><img alt=\"baner-glowny\" src=\"/baner1-2bc5e38bf5dbe6268563c285a9af4f71.png\"></div>\n</div>","fields":{"slug":"/Main-page-sekcja1/"},"frontmatter":{"title":"First Post","id":1}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-ff3452903a3023c4b2d2.js